import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlane } from "@fortawesome/free-solid-svg-icons";
import { IvaoTracker } from "../../components/ivao-tracker/ivao-tracker";
import { globalVariables } from "../../config";
import "./ivao-import.scss";

export function IvaoImport() {
    const { t } = useTranslation();

    return (
        <div className="view-model left ivao-import-page">
            <h1>
                {t("import-ivao-flights")} <FontAwesomeIcon icon={faPlane} />
            </h1>
            
            <div className="import-description">
                <p>{t("ivao-import-description")}</p>
                <ul>
                    <li>{t("ivao-import-requirement-1", { icaoCode: globalVariables.OACI })}</li>
                    <li>{t("ivao-import-requirement-2", { icaoCode: globalVariables.OACI })}</li>
                    <li>{t("ivao-import-requirement-3")}</li>
                </ul>
            </div>

            <IvaoTracker 
                onImportComplete={(result) => {
                    alert(t('ivao-import-success', { count: result.imported }));
                }}
            />
        </div>
    );
}